module.exports = __webpack_public_path__ + "static/media/S_7.03e2efc4.png";